<template>
    <thbfx :type="type" :timeType="timeType" :treeAddress="'/analysis/hbfx/hbfx3'"></thbfx>
</template>
<script>
    import thbfx from "../page/thbfx"
    export default {
        data() {
            return {
                type:"1",
                timeType:[
                    { type: "day", label: "日" },
                    { type: "month", label: "月" },
                    { type: "year", label: "年" }
                ]
            }
        },
        components:{
            thbfx
        }
    }
</script>